module.exports = __webpack_public_path__ + "static/media/Dark-florals-Milan-day1_thumb.8a0f5416.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fabrics-prints/Dark-florals-Milan-day1_thumb.jpg
// module id = 160
// module chunks = 0